export const enum MenuPages {
    Counting = "Counting",
    Addition = "Addition",
    Subtraction = "Subtraction",
    Multiplication = "Multiplication",
    Division = "Division",
    Topics = "Topics",
    Charts = "Charts",
    Blog = "Blog",
    GradeLevel = "GradeLevel",
    Home = "Home",
}